/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import RenderedAssetViewBase from '../../../global/components/AssetView/RenderedAssetViewBase';

import { tabs } from '../../../global/components/AssetView/Accordion';
import { useRouteLeaveHook } from '../../../global/lib/routeLeaveHook';

import { breadcrumbsActions } from '../../../global/state_managers/BreadcrumbsStateManager';

function HoldReasonRenderedAsset(props: any) {
  const dispatch = useDispatch();

  // useRouteLeaveHook returns the route/leave props (params, navigate,
  // registerUnmountCleanupMethod, ...) that the @routeLeaveHook HOC injects for
  // the sibling asset views. RenderedAssetViewBase requires params.asset_id and
  // registerUnmountCleanupMethod, so spread these down — discarding them was
  // crashing with "Cannot read properties of undefined (reading 'asset_id')".
  const routeLeaveProps = useRouteLeaveHook();

  useEffect(() => {
    dispatch(breadcrumbsActions.holdReasonsAssetsPage());
  }, [dispatch]);

  const visibleAccordions = [tabs.METADATA, tabs.HOLDS];

  return (
    <RenderedAssetViewBase
      {...props}
      {...routeLeaveProps}
      visibleAccordions={visibleAccordions}
    />
  );
}

export default HoldReasonRenderedAsset;
